/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Album } from '../models/Album';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class AlbumPasswordService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * A check whether the album is password protected or not. This can be used to determine whether to prompt the user for a password to view the album.
     * @param slug
     * @returns any Returned if the album is password protected.
     * @throws ApiError
     */
    public getAlbumSlugAuth(
        slug: string,
    ): CancelablePromise<{
        title?: string;
        slug?: string;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/admin/{slug}/auth/',
            path: {
                'slug': slug,
            },
            errors: {
                404: `Default Response`,
            },
        });
    }
    /**
     * Accepts an album slug and password, and sets a valid authentication token as a cookie to access the album.
     * @param slug
     * @param requestBody
     * @returns Album Default Response
     * @throws ApiError
     */
    public postAlbumSlugAuth(
        slug: string,
        requestBody: {
            password: string;
        },
    ): CancelablePromise<Album> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/admin/{slug}/auth/',
            path: {
                'slug': slug,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                403: `Default Response`,
            },
        });
    }
}
